import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { postRecalculateTaskCreateRequestActionCreator } from '../redux/actions/RecalculateTasksCreateActions';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import {
  getLeftPostalOperatorsCodesOnly,
  getOutboundImpcsOfSingleOperator,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import {
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
} from '../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class RecalculateTasksCreateDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: moment(),
      calculateFromDate: new Date(),
      impcCode: 'Select IMPC..',
      operatorCode: 'Select Operator..',
    };
    this.handleCalculateFromDate = this.handleCalculateFromDate.bind(this);
    this.handleNewOperator = this.handleNewOperator.bind(this);
    this.handleNewIMPC = this.handleNewIMPC.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
  }

  isFormValid = () => !(this.state.impcCode === 'Select IMPC..' || this.state.calculateFromDate === 'Invalid date'
    || this.state.operatorCode === 'Select Operator..')

  handleNewOperator(selectedOption) {
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      operatorCode: selectedOption.value,
      impcCode: 'Select IMPC..',
    });
  }

  handleNewIMPC(selectedOption) {
    this.setState({
      impcCode: selectedOption.value,
    });
  }

  handleCalculateFromDate(date) {
    const newDate = moment(date);
    this.setState({
      calculateFromDate: newDate.format('YYYY-MM-DD'),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmCreate() {
    await this.props.postRecalculateTaskCreateRequestActionCreator(
      this.props.appContext,
      this.state.calculateFromDate,
      this.state.impcCode,
    );
    this.props.closeDialog();
    this.props.refreshTransactions();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Create Recalculate Task Manually</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorCode}
                    placeholder={this.state.operatorCode}
                    options={this.props.operatorOptions}
                    onChange={this.handleNewOperator}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcCode}
                    placeholder={this.state.impcCode}
                    options={this.mapImpcListToSelectOptions(this.props.impcList)}
                    onChange={this.handleNewIMPC}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Calculate From
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.calculateFromDate}
                        onChange={this.handleCalculateFromDate}
                        maxDate={this.state.currentDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmCreate}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

RecalculateTasksCreateDialog.propTypes = {
  appContext: PropTypes.objectOf(PropTypes.shape),
  postRecalculateTaskCreateRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  operatorOptions: PropTypes.arrayOf(PropTypes.object),
  getImpcsOfSingleOutboundOperatorRequestActionCreator: PropTypes.func,
  impcList: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    operatorOptions: getLeftPostalOperatorsCodesOnly(state),
    impcList: getOutboundImpcsOfSingleOperator(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postRecalculateTaskCreateRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RecalculateTasksCreateDialog);
